export default {"src":"/_next/static/media/decorative-lines.46d7723c.svg","height":28,"width":33,"blurWidth":0,"blurHeight":0};